// Third Party Imports
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import PropTypes from 'prop-types';

// Relative Imports
import './BillingSetupContainer.less';
import actions from '../../actions/actions';
import helpActions from '../../actions/help';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import MainContent from '../MainContent/MainContent';
import {getPreferredLocale} from '../../utils/localStorageDataHandler';
import {FOP} from '../../utils/constants'

import VatInformation from "../VatInformation/VatInformationContainer";
import CompanyLocation from "../CompanyLocation/CompanyLocationContainer";
import InformationPage from "../InformationPage/InformationPageContainer";
import MailingInformation from "../MailingInformation/MailingInformationContainer";
function mapStateToProps(state) {
    return {
        appState: state.app.appState,
        enableLoadOverlay: state.app.enableLoadOverlay,
        publicUuid: state.app.publicUuid,
        authState: state.app.authState,
        translations: state.app.translations,
        brandName: state.system.brandName,
        siteName: state.system.siteName,
        urlPrefix: state.app.config.urlPrefix,
        logoBrandName: state.system.logoBrandName,
        footerData: state.app.footerData,
        supportedLocales: state.app.supportedLocales,
        locale: state.system.locale,
        preferredLocale: state.system.preferredLocale,
        environment: state.system.environment,
        nodeEnvironment: state.system.nodeEnvironment,
        redirectPath: state.app.redirectPath,
        billingPageRedirect: state.billingSetup.billingPageRedirect
    };
}

function mapDispatchToProps(dispatch) {
    return {
        helpActions: bindActionCreators(helpActions, dispatch),
        actions: bindActionCreators(actions, dispatch),
        dispatch
    };
}

@connect(mapStateToProps, mapDispatchToProps)
class BillingSetupContainer extends React.Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {
        if (this.props.authState) {
            this.handlePreferredLocale();
        }

        if (this.props.redirectPath) {
            if (typeof window !== 'undefined') {
                let {protocol, host, pathname} = window.location;
                pathname = this.props.redirectPath;
                const appUrl = (pathname === '/') ? `${protocol}//${host}${pathname}` : `${protocol}//${host}${pathname}?site=vrbo`;
                window.location = appUrl;
            }
        }
    }

    handlePreferredLocale = () => {
        const {publicUuid, preferredLocale, authState} = this.props;

        if (authState) {
            const savedLocale = getPreferredLocale(publicUuid);
            if (savedLocale) {
                if (savedLocale !== preferredLocale) {
                    this.redirectToNewLocale(savedLocale);
                }
            } else if (!this.isLocaleRedirectEligible()) {
                this.props.actions.savePreferredLocale(publicUuid, preferredLocale);
            }
        }
    }

    isLocaleRedirectEligible = () => (this.props.locale === this.props.preferredLocale);

    redirectToNewLocale = (locale) => {
        if (typeof window !== 'undefined') {
            const {protocol, host, pathname, search} = window.location;
            const appUrl = `${protocol}//${host}${pathname}`;
            const localParamStr = `locale=${locale}`;
            window.location = search ? `${appUrl}${search}&${localParamStr}` : `${appUrl}?${localParamStr}`;
        }
    }

    redirectToFop = () => {
        const {siteName, environment, nodeEnvironment, billingPageRedirect} = this.props;
        if (typeof window !== 'undefined') {
            let {protocol, host} = window.location;
            let {basePath} = window.__SITE_CONTEXT__;
            basePath = basePath || '';
            if (environment === 'development') {
                host = 'test.vrbo.com';
            } else if (environment === 'stage' && nodeEnvironment === 'development') {
                host = 'stage.vrbo.com';
            }
            let appUrl = `${protocol}//${host}${basePath}${FOP.suffix}?redirect=${billingPageRedirect? billingPageRedirect : 'pas'}`;
            if (siteName === 'homeaway_us') {
                appUrl = `${appUrl}&site=${siteName}`;
            }
            window.location.replace(`${appUrl}`);
        }
    };


    // eslint-disable-next-line complexity
    render() {
        const {
            appState,
            authState,
            translations,
            enableLoadOverlay,
            footerData
        } = this.props;

        let panelContent;
        let skipHeader = false;
        let skipMainContainer = true;
        let skipFooter = true;
        let isLandingPage = false;

        switch (appState) {
            case 'MAILING_INFORMATION':
                panelContent = <MailingInformation />;
                break;
            case 'COMPANY_LOCATION':
                panelContent = <CompanyLocation />;
                break;
            case 'VAT_INFORMATION':
                panelContent = <VatInformation />;
                break;
            case 'BILLING_INFORMATION':
                this.redirectToFop();
                break;
            case 'INELIGIBLE':
                panelContent = <InformationPage messageKey={'NOT_ELIGIBLE'} />;
                break;
            default:
                panelContent = <InformationPage messageKey={'ERROR'} />;
                break;
        }

        return (
            <div>
                <Header
                    authState={authState}
                    translations={translations}
                    skipComponent={skipHeader}
                    triggerEdapEvent={this.props.actions.triggerEdapEvent}
                    toggleHelpModal={this.props.helpActions.toggleHelpModal}
                    siteName={this.props.siteName}
                    changeAppState={this.props.actions.changeAppState}
                    isLandingPage={isLandingPage}
                    logoBrandName={this.props.logoBrandName}
                    supportedLocales={this.props.supportedLocales}
                    preferredLocale={this.props.preferredLocale}
                    savePreferredLocale={this.props.actions.savePreferredLocale}
                    publicUuid={this.props.publicUuid}
                    environment={this.props.environment}
                    nodeEnvironment={this.props.nodeEnvironment}
                />
                <MainContent
                    panelContent={panelContent}
                    skipComponent={skipMainContainer}
                    enableLoadOverlay={enableLoadOverlay}
                />
                <Footer
                    translations={translations}
                    skipComponent={skipFooter}
                    isLandingPage={isLandingPage}
                    footerData={footerData}
                />
            </div>
        );
    }
}

BillingSetupContainer.propTypes = {
    appState: PropTypes.oneOf([
        'COMPANY_LOCATION',
        'VAT_INFORMATION',
        'BILLING_INFORMATION',
        'ERROR'
    ]),
    authState: PropTypes.bool,
    translations: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    enableLoadOverlay: PropTypes.bool,
    billingPageRedirect: PropTypes.string,
    isBillingSetupFlow: PropTypes.bool,
};

export default BillingSetupContainer;
